import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

@Component({
  template: `
    <div style="max-width: 250px;margin-left: auto;margin-right: auto;">
      <risk-heat-bar [risk]="rating"></risk-heat-bar>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RatingBarComponent extends DataWidgetComponent implements OnInit {
  @Input()
  data: MobileAppPtiRanking;

  rating: string;

  ngOnInit(): void {
    super.ngOnInit();

    this.rating = this.data[this.key];
  }
}
